<template>
    <div>
        <compFormQuery v-if="alltype=='query'" class="margin-top-15 margin-right-15" :formdata="getClear" :value="formData" :labelWidth="165"></compFormQuery>
		<compFormEdit v-else class="margin-top-15 margin-right-15" :formdata="getClear" v-model="formData" :labelWidth="165"></compFormEdit>

        <div class="padding-left-30 products-icons">
            <div class="products-tagname">{{$t('erp.product.product_label',{defaultValue:'产品标签'})}}</div>
			<div class="products-tagul add-tag">
				<ul class="products-ullist" v-if="alltype!='query'">
					<li class="products-tag-li" v-for="(item,index) in choseList" :key="index">
						<span class="products-span products-tag-span" :class="item.labelColour">
							<span class="products-tag-name">{{item.labelName}}</span>
						</span>
						<Icon class="products-icon-remove" type="md-close" @click="removeIcons(item.id)"></Icon>
					</li>
					<li class="margin-left-10">
						<vButton @click="addiconbox">{{$t('global.common.operation_add',{defaultValue:'添加'})}}</vButton>
						<comAddicon @on-closebox="closebox" @on-update="updateForm"  @on-checkout="checklist" v-if="showaddicon" :labelList="iconids"></comAddicon>
					</li>
				</ul>
				<ul class="products-ullist" v-else>
					<li class="products-othertag-li" v-for="(item,index) in choseList" :key="index">
						<span class="products-span products-tag-span" :class="item.labelColour">
							<span class="products-tag-name">{{item.labelName}}</span>
						</span>
					</li>
				</ul>
			</div>

        </div>
    </div>
</template>

<script>
import comAddicon from './allproducts/addicon'
import {
	HttpGetIconList,
	HttpDeleteIconOne
} from '@/service/products/allproducts'
export default {
	props:['alltype','otherformdata'],
    data(){
        return {
            formData:{
				returnDealMethod:0,
				isDistribution:0,
				productMidCondition:'',
				productMidModel:'',
				productMidMeta:'',
				productMidStandard:'',
			},
			showaddicon:false,
			tagColorList:[
				{color:'ICblue'},
				{color:'ICgreen'},
				{color:'ICdeepgreen'},
				{color:'ICpurple'},
				{color:'ICorange'},
				{color:'ICred'},
			],
			iconsList:[],
			choseList:[],
			iconids:"",
			valueList:[
				{value:this.$t('erp.product.handing_method_for_damage_of_return_undetermined', { defaultValue: '客户自提' })},
                {value:this.$t('erp.product.handing_method_for_damage_of_return_first_warehousing', { defaultValue: '拍照确认' })},
                {value:this.$t('erp.product.destruction',{defaultValue:'销毁'})},
                // {value:this.$t('erp.product.handing_method_for_damage_of_return_accessories', { defaultValue: '当做配件补发' })},
            ],
            returnDealMethod:0,
        }
    },
    components: {
		compFormQuery: () => import("@components/templates/formquery"),
		compFormEdit: () => import("@components/templates/formedit"),
		comAddicon,
	},
    computed:{
        getClear(){
            return [
                // 1
				{
					label: this.$t('erp.product.returndetail_method',{defaultValue:'客退货物外观破损处理方式'}),
					key: "returnDealMethod",
					tag: "vSelect",
					required:false,
                    options: [
                        {value:2, label:this.$t('erp.product.destruction',{defaultValue:'销毁'})},
                        {value:1,label:this.$t('erp.product.handing_method_for_damage_of_return_first_warehousing', { defaultValue: '拍照确认' })},
                        {value:0,label:this.$t('erp.product.handing_method_for_damage_of_return_undetermined', { defaultValue: '客户自提' })},
                        // {value:3, label: this.$t('erp.product.handing_method_for_damage_of_return_accessories', { defaultValue: '当做配件补发' })}
                    ],
                    props: {
						filterable: true,
						placeholder:this.$t('global.common.choose',{defaultValue:'请选择'})
					},
					show:this.alltype !='query'
				},
				{
					label: this.$t('erp.product.returndetail_method',{defaultValue:'客退货物外观破损处理方式'}),
					span:12,
					query:true,
					valueText:this.valueList[this.formData.returnDealMethod].value,
					show:this.alltype =='query'
				},
				{
					label: this.$t('erp.product.allow_distribution',{defaultValue:'是否允许分销'}),
					key: "isDistribution",
					tag: "vRadio",
					required: false,
					show: this.type != 'query',
					props: {
						strict: false,
					},
					options: [{
						trueValue: 1,
						label: this.$t('erp.global.yes',{defaultValue:'是'})
					}, {
						trueValue: 0,
						label: this.$t('erp.global.no',{defaultValue:'否'})
					}],
					formItem:{
						tip: !this.showquery ? '' : `<div class="color-error">（${this.$t('erp.product.add_repack', { defaultValue: '加运输包装即需要repack' })}）</div>`,
					}
                },
                {
					label: this.$t('erp.product.allow_distribution',{defaultValue:'是否允许分销'}),
					key: "isDistribution",
					show: this.type == 'query',
					valueText: this.formData.isDistribution == 1 ? this.$t('erp.global.yes',{defaultValue:'是'}) : this.$t('erp.global.no',{defaultValue:'否'})
				},
                {
                    label: this.$t('erp.product.condition',{defaultValue:'状况'}),
                    key: "productMidCondition",
                    required: false,
                    tag:'vInput',
                },
                {
                    label: this.$t('erp.product.model',{defaultValue:'型号'}),
                    key: "productMidModel",
                    required: false,
                    tag:'vInput',
                },
                {
                    label: this.$t('global.common.notes',{valuekey:'1',defaultValue:'备注1'}),
                    key: "productMidMeta",
                    required: false,
                    tag:'vInput',
                },
                {
                    label: this.$t('global.common.notes',{valuekey:'2',defaultValue:'备注2'}),
                    key: "productMidStandard",
                    required: false,
                    tag:'vInput',
                },
            ]
        },
	},
	methods:{
		handledata(){
			// console.log(this.otherformdata)
			this.formData.returnDealMethod = this.otherformdata.returnDealMethod || 0;
			this.formData.isDistribution = this.otherformdata.isDistribution || 0;
			this.iconids = this.otherformdata.productLabel || ""; //产品添加的id

			this.formData.productMidCondition = this.otherformdata.productMidCondition
			this.formData.productMidModel = this.otherformdata.productMidModel
			this.formData.productMidMeta = this.otherformdata.productMidMeta
			this.formData.productMidStandard = this.otherformdata.productMidStandard
			this.updateForm()
		},
		checklist(obj){
			// console.log(obj,this.choseList)
			// choseList
			if(obj.hide == true){
				this.choseList.push(obj)
			}else{
				for(let i =0;i <this.choseList.length;i++){
					if(this.choseList[i].id == obj.id){
						this.choseList.splice(i,1);
					}
				}
			}
		},
		addiconbox(){
			this.showaddicon = true;
		},
		closebox(){
			this.showaddicon = false;
		},
		updateForm(){
			HttpGetIconList().then(res=>{
				// console.log(res.data)
				// console.log(this.iconids)
				this.iconsList = res.data
				let arr = this.iconids.split(",") || [];
				// console.log(arr)
				if(arr.length>0){
					for(let i=0;i<arr.length;i++){
						for(let j=0;j<this.iconsList.length;j++){
							if(arr[i] == this.iconsList[j].id){
								// console.log(arr[i],this.iconsList[j].id)
								this.choseList.push(this.iconsList[j])
							}
						}
					}
				}
			// console.log(this.choseList)
			},err=>{
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			})

		},
		removeIcons(id){
			
			for(let i =0;i <this.choseList.length;i++){
				if(this.choseList[i].id == id){
					this.choseList.splice(i,1);
				}
			}
			let stringarr = this.choseList.map(item=>{
				return item.id
			})
			this.iconids = stringarr.join(',')
		}
	},
    watch:{
        otherformdata(){
            this.handledata()
        }
    }
}
</script>
